var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34467 12.8889L1.28911 17.4444C1.2527 17.6109 1.25395 17.7835 1.29276 17.9495C1.33158 18.1155 1.40699 18.2707 1.51348 18.4038C1.61997 18.5369 1.75485 18.6446 1.90826 18.7189C2.06168 18.7932 2.22976 18.8323 2.40022 18.8333C2.47965 18.8413 2.55968 18.8413 2.63911 18.8333L7.22244 17.7778L16.0224 9.01108L11.1113 4.11108L2.34467 12.8889Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7886 4.62231L15.5109 1.34454C15.2954 1.13013 15.0037 1.00977 14.6997 1.00977C14.3957 1.00977 14.1041 1.13013 13.8886 1.34454L12.0664 3.16676L16.972 8.07231L18.7942 6.25009C18.9008 6.14291 18.9853 6.01576 19.0427 5.87591C19.1002 5.73605 19.1295 5.58624 19.129 5.43505C19.1284 5.28386 19.0981 5.13425 19.0397 4.9948C18.9813 4.85534 18.896 4.72876 18.7886 4.62231Z",
    fill: "#4D4D4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.3a0b0a1b.svg";
export { ForwardRef as ReactComponent };